import { ProductRouteError } from "@/session/product-route-frame";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { getPlayDestination } from "@/features/play/records";
import { PlayIndexPage, PlayPending } from "@/features/play";

export const Route = createFileRoute("/_site/play/")({
  beforeLoad: async ({ abortController }) => {
    const href = await getPlayDestination({ signal: abortController.signal });

    if (href) throw redirect({ href, statusCode: 307 });
  },
  pendingComponent: PlayPending,
  errorComponent: ProductRouteError,
  head: () => ({
    meta: [
      { title: "Play · Softmax" },
      { name: "robots", content: "noindex, follow" },
    ],
  }),
  component: PlayIndexPage,
});
